import { gql } from "urql";

// Get MissingInformationRecord by id query

export const missingInformationRecordQuery = gql`
    query MissingInformationRecordQuery($recordId:Int!) {
        missingInformationRecord(recordId:$recordId) {
            id
            created
            topic
            details
            personalityName
        }
    }
`;

export type * from "./__generated__/missing-information-record-query";

// MissingInformationRecord page query

export const missingInformationPageQuery = gql`
    query MissingInformationPageQuery($page:Int!, $personalityName:String) {
        missingInformationPage(page:$page, personalityName:$personalityName) {
            items {
                id
                created
                topic
                personalityName
            }
            maxPage
        }
    }
`;

export type * from "./__generated__/missing-information-page-query";

// Get unique personality names for filter dropdown

export const personalityNamesQuery = gql`
    query MissingInformationPersonalityNamesQuery {
        missingInformationPersonalityNames
    }
`;

export type * from "./__generated__/missing-information-personality-names-query";

// Delete MissingInformationRecord mutation

export const deleteMutation = gql`
    mutation MissingInformationDeleteMutation($recordId:Int!) {
        missingInformationDelete(recordId:$recordId) {
            id
            topic
        }
    }
`;

export type * from "./__generated__/missing-information-delete-mutation";
